export default __webpack_public_path__ + "static/media/sg.d1dbd2e7.svg";